module.exports = __webpack_public_path__ + "img/b8950f7.gif";